/* eslint-disable @typescript-eslint/camelcase */
import { Grid } from '@material-ui/core';
import { EnvironmentFields } from 'modules/environments/interfaces';
import React from 'react';
import i18n from 'i18n';
import { getDashboardSessionsGraphRequest } from 'modules/environments/actions';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { RolesEnum } from 'modules/authenticate/interfaces';
import { isClientOperator } from 'utils/role';
import Permission from 'components/ValidPermission';
import EnvironmentInstancesCard from './EnvironmentInstancesCard';
import SessionsHistoryGraphCard from './SessionsHistoryGraphCard';

interface Props {
  environment: EnvironmentFields | null;
  role?: RolesEnum;
  intervalTime: string;
  getDashboardSessionsGraphRequest: ({ id, intervalTime }) => void;
}

const EnvironmentDashboard = ({ environment, role }: Props) => {
  const [monitor, setMonitor] = React.useState({
    operational: 0,
    total_instances: 0,
    average_memory_usage: 0,
    average_cpu_usage: 0,
    license_usage: 0,
    license_limit: 0,
  });

  React.useEffect(() => {
    if (!environment) return;

    const {
      licenses: { license_limit },
      metrics: { scale_instances, sessions },
    } = environment;

    const formatValue = (value: number) => Math.round(value * 100) / 100;

    setMonitor({
      operational: formatValue(
        (scale_instances?.total_instances_by_states.operational /
          scale_instances?.total_instances) *
          100 || 0
      ),
      total_instances: formatValue(scale_instances?.total_instances),
      average_memory_usage: formatValue(scale_instances?.average_memory_usage),
      average_cpu_usage: formatValue(scale_instances?.average_cpu_usage),
      license_usage: sessions?.total,
      license_limit,
    });
  }, [environment]);

  return (
    <Grid container spacing={2} alignItems="flex-end">
      <EnvironmentInstancesCard
        title={i18n.t('STATE_OPERATIONAL_KEY')}
        value={`${Math.round(monitor?.operational)}%`}
        subtitle={i18n.t('TOTAL_INSTANCES_KEY')}
        subtitleValue={String(monitor?.total_instances)}
      />
      {!isClientOperator(role) && (
        <EnvironmentInstancesCard
          title={i18n.t('TOTAL_LICENSES_USAGE_KEY')}
          value={String(monitor?.license_usage)}
          subtitle={i18n.t('TOTAL_LICENSES_CONTRACT_KEY')}
          subtitleValue={String(monitor?.license_limit)}
        />
      )}
      <EnvironmentInstancesCard
        title={i18n.t('AVERAGE_CPU_USAGE_KEY')}
        value={`${Math.round(monitor?.average_cpu_usage)}%`}
        subtitle={i18n.t('AVERAGE_MEMORY_USAGE_KEY')}
        subtitleValue={`${Math.round(monitor?.average_memory_usage)}%`}
      />
      <Permission value="list_environment_dashboard">
        <SessionsHistoryGraphCard />
      </Permission>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { isLoading, dashboardSessionsGraph, periodFilter },
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  isLoading,
  dashboardSessionsGraph,
  companySelected,
  role: data?.role,
  intervalTime: periodFilter,
});

export default connect(mapStateToProps, {
  getDashboardSessionsGraphRequest,
})(EnvironmentDashboard);
